// 20.1.2.12 Number.parseFloat(string)
var $export = require('./$.export');

$export($export.S, 'Number', {parseFloat: parseFloat});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es6.number.parse-float.js
// module id = 220
// module chunks = 0